import { Box, Button, Tooltip, Typography, styled } from "@mui/material";
import { t } from "i18next";
import {
  ArrowBackIcon,
  CloudUploadIcon,
  DriveFileRenameOutlineIcon,
} from "../../icons/index.tsx";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { addNotice, editNotice, getNoticeDetail } from "common-lib";
import { handleTextFieldChange } from "../../utils/utils.ts";
import { CustomMuiButton } from "../../utils/styleUtils.js";

export default function NoticeFormPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [title, setTitle] = useState(null);
  const [content, setContent] = useState(null);
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const handleBackClick = () => {
    navigate("/home", { state: { tab: "notice" } });
  };

  const fetchDetailData = async () => {
    try {
      const response = await getNoticeDetail(id);
      const data = response.data;
      setTitle(data.title);
      setContent(data.content);
    } catch (error) {
      console.error(error);
    }
  };

  const handleCancel = () => {
    navigate("/home", { state: { tab: "notice" } });
  };

  const handleApply = async () => {
    try {
      const response = await addNotice({
        title: title,
        content: content,
        user_no: userInfo.id,
      });
      navigate("/home", { state: { tab: "notice" } });
      toast.success("공지사항이 등록되었습니다.");
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = async () => {
    try {
      const response = await editNotice(id, {
        title: title,
        content: content,
        user_no: userInfo.id,
      });
      navigate("/home", { state: { tab: "notice" } });
      toast.success("공지사항이 수정되었습니다.");
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || "Error editing notice");
    }
  };

  useEffect(() => {
    if (id) {
      fetchDetailData(id);
    }
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        p: 3,
      }}
    >
      <Box sx={{ display: "flex" }}>
        <Button
          className="add-button"
          onClick={handleBackClick}
          sx={{ color: "var(--button-color)" }}
        >
          <ArrowBackIcon /> <span>{t("Notice")}</span>
        </Button>
      </Box>
      <Box sx={{ height: "100%", width: "100%", marginTop: 3 }}>
        <Typography
          sx={{
            mb: 1,
            fontWeight: "700",
            fontSize: 24,
            display: "flex",
            alignItems: "center",
          }}
          fontFamily={"NotoSansKR-Variable"}
        >
          <DriveFileRenameOutlineIcon sx={{ marginRight: "5px" }} />
          {id ? t("EditNotice") : t("CreateNewNotice")}
        </Typography>
        <Typography variant="body1">
          팀 또는 커뮤니티와 중요한 업데이트를 공유하세요.
        </Typography>
        <div className="input-container">
          <input
            type="text"
            id="input-field"
            placeholder="제목을 입력해주세요"
            value={title}
            onChange={handleTextFieldChange(setTitle)}
          />
          <label htmlFor="input-field">제목</label>
        </div>
        <div className="input-container" style={{ marginBottom: "0px" }}>
          <textarea
            type="text"
            id="input-field"
            placeholder="내용을 입력해주세요"
            style={{ height: "400px" }}
            value={content}
            onChange={handleTextFieldChange(setContent)}
          />
          <label htmlFor="input-field">내용</label>
        </div>
        <Box
          sx={{
            width: "100%",
            height: "60px",
            p: 1,
            border: "1px dashed #ccc",
            display: "flex",
            alignItems: "center",
          }}
        >
          <InputFileUpload />
        </Box>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            marginTop: 3,
          }}
        >
          {id ? (
            <>
              <CustomMuiButton
                onClick={handleCancel}
                variant="text"
                label={t("Cancel")}
              />
              <CustomMuiButton
                onClick={handleEdit}
                variant="contained"
                label={t("Edit")}
              />
            </>
          ) : (
            <>
              <CustomMuiButton
                onClick={handleCancel}
                variant="text"
                label={t("Cancel")}
              />
              <CustomMuiButton
                onClick={handleApply}
                variant="contained"
                label={t("Apply")}
              />
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

function InputFileUpload() {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFilesName, setSelectedFilesName] = useState([]);

  const handleUpload = (event) => {
    const files = event.target.files;
    console.log(files);

    console.log(files[0].name);

    const fileNames = Array.from(files).map((file) => file.name);
    console.log(fileNames);
    setSelectedFilesName((prev) => [...prev, ...fileNames]);
    setSelectedFiles((prev) => [...prev, ...files]);
  };

  return (
    <>
      <Button
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={<CloudUploadIcon />}
        sx={{ mr: 1 }}
      >
        Upload files
        <VisuallyHiddenInput type="file" onChange={handleUpload} multiple />
      </Button>
      {selectedFilesName.length === 1 && (
        <Typography>{selectedFilesName[0]}</Typography>
      )}
      {selectedFilesName.length > 1 && (
        <Tooltip
          title={
            <>
              {selectedFilesName.map((file, idx) => (
                <span key={idx}>
                  {file}
                  <br />
                </span>
              ))}
            </>
          }
        >
          <Typography>
            {selectedFilesName[0]} 외 {selectedFilesName.length - 1}장
          </Typography>
        </Tooltip>
      )}
    </>
  );
}
